import React, { useCallback, useState } from 'react';
import Context, { LookUpData } from './Context';

const defaultValue: LookUpData = {
  flow: '',
  locked: false,
  lockoutExpiryTime: '',
  lookupId: '',
  emailAddress: '',
  currentEmailAddress: '',
  mfa: {
    communicationDetails: [],
    mnoEnabled: false,
    mfaOTPSessionKey: ''
  },
  personalInfoFormFlag: true,
  addressInfoFormFlag: false,
  onlyDOBFieldFlag: false,
  onlyDOBFieldLastAttemptFlag: false,
  pbmUserFormFlag: false,
  showMemberId: false,
  communicationDetails: [
    {
      key: '',
      value: ''
    }
  ],
  appProps: {
    adobeFlowName: '',
    source: '',
    title: '',
    description: '',
    addrTitle: '',
    addrDescription: ''
  }
};

const Provider = ({ children }) => {
  const [lookupData, setLookUpData] = useState<LookUpData>(defaultValue);

  const updateLookupData = useCallback(
    (value: LookUpData) => setLookUpData((oldUser) => ({ ...oldUser, ...value })),
    [setLookUpData]
  );

  const UserContext = {
    lookupData,
    updateLookupData
  };
  return <Context.Provider value={UserContext}>{children}</Context.Provider>;
};

export default Provider;
